import React from 'react';
import i18n from '../../../../../i18n';
import { fmt, numberLocale } from '../../../data/metrics';
import type { DrillGuestsHero as GuestsHero } from '../../../types';
import { Delta } from '../../shared/Delta';

/** Percent change of `value` against `compare`, one decimal; null without a base. */
export function pctChange(value: number | null | undefined, compare: number | null | undefined): number | null {
  if (value == null || compare == null || !compare) return null;
  return Math.round(((value - compare) / compare) * 1000) / 10;
}

/** Guests drill hero line: guests per operating day, and walk-in guests
 *  next to guests on reservations. */
export function DrillGuestsHero({
  hero,
  compareLabel,
}: {
  hero?: GuestsHero;
  /** The compare period, when one is on: the per-day figure gets its change. */
  compareLabel?: string;
}) {
  if (!hero) return null;
  const perDay = hero.guestsPerOperatingDay;
  const comparePerDay = compareLabel ? hero.compareGuestsPerOperatingDay : undefined;
  const perDayChange = pctChange(perDay, comparePerDay);
  return (
    <div className="drill-toolbar-sub" data-testid="drill-guests-hero">
      {perDay != null ? (
        <span
          title={i18n.t('performance:drillUi.opDays', {
            count: hero.operatingDays,
          })}
        >
          <b>{perDay.toLocaleString(numberLocale(), { maximumFractionDigits: 1 })}</b>{' '}
          {i18n.t('performance:drillUi.guestsPerOpDay')}
          <span className="drill-toolbar-sub-muted">
            {' '}
            ({i18n.t('performance:drillUi.opDays', { count: hero.operatingDays })})
          </span>
          {perDayChange != null && comparePerDay != null ? (
            <span
              className="drill-toolbar-sub-delta"
              title={`${compareLabel}: ${comparePerDay.toLocaleString(numberLocale(), { maximumFractionDigits: 1 })}`}
            >
              {' '}
              <Delta value={perDayChange} size={12} />
            </span>
          ) : null}
        </span>
      ) : null}
      <span
        title={i18n.t('performance:drillUi.walkInSplitTitle', {
          walkIns: fmt.num(hero.walkInGuests),
          reservations: fmt.num(hero.reservationGuests),
        })}
      >
        <b>{fmt.num(hero.walkInGuests)}</b> {i18n.t('performance:drillUi.walkIns')} ·{' '}
        <b>{fmt.num(hero.reservationGuests)}</b> {i18n.t('performance:drillUi.onReservations')}
      </span>
    </div>
  );
}
